import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import React, { useContext } from 'react';
import WeekStartsOnOverrideContext from '../contexts/WeekStartsOnOverrideContext';
import Row from './Common/Row';
import { POPUP_REPORT_HEIGHT } from './ReportCanvas/canvasConstants';
import { InjectedComponentsContext } from '../contextProviders/InjectedComponentsProvider/context';

const PopupReport = ({
  report,
  isOpen,
  close,
  parentDashboardGadget,
  unSavedFilter,
}: {
  report?: ReportType;
  isOpen: boolean;
  close: () => void;
  parentDashboardGadget?: DashboardGadget;
  unSavedFilter?: UnSavedFilter;
}) => {
  const { Report } = useContext(InjectedComponentsContext);

  return (
    <ModalTransition>
      {isOpen && report && (
        <Modal
          height={POPUP_REPORT_HEIGHT.MODAL_HEIGHT}
          width={'95vw'}
          onClose={close}
          shouldScrollInViewport={false}
          autoFocus={false}
        >
          <WeekStartsOnOverrideContext.Provider
            value={{
              weekStartsOnOverride:
                parentDashboardGadget &&
                parentDashboardGadget.weekStartsOnOverride
                  ? parentDashboardGadget.weekStartsOnOverride
                  : undefined,
            }}
          >
            <Row style={{ flex: 1 }}>
              <div style={{ width: '100%', display: 'flex', flex: 1 }}>
                <Report
                  report={report}
                  hideMenu
                  parentDashboardGadget={parentDashboardGadget}
                  unSavedFilter={unSavedFilter}
                />
              </div>
            </Row>
          </WeekStartsOnOverrideContext.Provider>
        </Modal>
      )}
    </ModalTransition>
  );
};

export default PopupReport;
